import _ from 'lodash'

export function cleanLayoutStations (layout, settingsBlob) {
  const stations = settingsBlob.stations.map(next => next.id)

  for (let layoutTab of _.values(_.get(layout, 'tabs', {}))) {
    const intersection = _.intersection(stations, layoutTab.limitStations.stations)
    if (intersection.length < layoutTab.limitStations.stations.length) {
      layoutTab.limitStations.stations = intersection

      if (_.isEmpty(intersection) && layoutTab.limitStations.enabled) {
        layoutTab.limitStations.enabled = false
      }
    }
  }
}
